import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { CONSTANTS } from "../constants/constants";
import { environment } from "../../../environments/environment";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class MarketUpdateService {
  constructor(private readonly http: HttpClient) {}

  headers = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

  getMarketUpdates(PoolID: number, PageIndex: number, PageZise: number) {
    const url = environment.BASE_API_URL + CONSTANTS.API.MARKET.MARKET_UPDATE;
    const params = {
      PoolID: PoolID.toString(),
      PageIndex: PageIndex.toString(),
      Pagesize: PageZise.toString(),
    };
    return this.http.get<any>(url, { ...this.headers, params });
  }

  getDetailCommentaryById(id?: number) {
    return this.http.get(
      environment.BASE_API_URL + CONSTANTS.API.MARKET.DETAIL_COMMENTARY,
      {
        ...this.headers,
        params: {
          id: id + "",
        },
      }
    );
  }

  getMarketUpdatesFilter(
    PoolID: number,
    PageIndex: number,
    PageSize: number,
    divisionIDs: number[] = [],
    option = {}
  ) {
    const url = environment.BASE_API_URL + CONSTANTS.API.MARKET.MARKET_UPDATE;
    const params = {
      poolId: PoolID.toString(),
      pageIndex: PageIndex.toString(),
      pageSize: PageSize.toString(),
      ...option,
    };

    return this.http
      .post<any>(url, divisionIDs, { ...this.headers, params })
      .pipe(
        map((res) => {
          res.result.data = res.result.data ?? [];
          return res;
        })
      );
  }
}
